/**
 * Safe access to the browser PostHog instance.
 * Must never throw — analytics must not block UX flows.
 */

type PostHogBrowser = {
  capture: (event: string, properties?: Record<string, unknown>) => void;
  identify: (distinctId: string, properties?: Record<string, unknown>) => void;
  group: (groupType: string, groupKey: string, properties?: Record<string, unknown>) => void;
  reset: () => void;
  get_distinct_id: () => string;
  get_session_id: () => string | undefined;
  captureException?: (error: Error, properties?: Record<string, unknown>) => void;
};

export function getBrowserPostHog(): PostHogBrowser | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    return (window as { posthog?: PostHogBrowser }).posthog;
  } catch {
    return undefined;
  }
}
